<template>
  <z-focus-group-collection>
    <z-roving-focus-group-impl v-bind="$attrs">
      <slot />
    </z-roving-focus-group-impl>
  </z-focus-group-collection>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ZRovingFocusGroupImpl from './roving-focus-group-impl.vue'
import { ZCollection as ZFocusGroupCollection } from './roving-focus-group'

export default defineComponent({
  name: 'ZRovingFocusGroup',
  components: {
    ZFocusGroupCollection,
    ZRovingFocusGroupImpl,
  },
})
</script>
